<template>
  <div id="UnitsWithoutActiveContractsReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Units Without Active Contracts</div>
          <div class="web-action-btn btn-groups text-right">
            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
              <i class="fp-export"></i> Export
            </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'unitsWithoutActiveContractsReport'" ref="filterComponent"
                                      @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process.
                batch no. is {{ batchNum }}.
                <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank"
                             @click.native="batchProcess = 0"> Click Here
                </router-link>
                to check file status!
              </p>
              <section class="bg-white data-table">
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'unitsWithoutActiveContractsReport'"
                  :position="'top'">
                </custom-pagination>

                <vue-good-table
                  ref="unitsWithoutActiveContractsReportTable"
                  mode="remote"
                  title="Reservations"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :isLoading=false
                  :paginationOptions="{
                            enabled: false,
                            position: 'both',
                            perPage: perPage,
                            dropdownAllowAll: false,
                            setCurrentPage:listCurrentPage,
                            perPageDropdown:dropDownPerPage,
                        }"
                  :search-options="{
                        enabled: false,
                        }"
                >
                </vue-good-table>
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
  name: "unitsWithoutActiveContractsReport",
  mixins: [commonMixins, dataTableMixins],
  data: () => ({
    cantAccessPage: "",
    loading: false,
    action: "list",
    permissions: [],
    rows: [],
    totalRecords: 0,
    userColumns: [],
    columns: [
      {
        label: "Unit#",
        field: "unit",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: "Ownership",
        field: "ownership",
        fpFieldType: "option",
        filterable: true,
        hidden: false,
      },
      {
        label: "Equipment Type",
        field: "equipment_type",
        fpFieldType: "option",
        filterable: true,
        hidden: false,
      },
      {
        label: "Equipment Sts",
        field: "equipment_status",
        fpFieldType: "option",
        filterable: true,
        hidden: false,
        filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Contract Equipment Status", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [{text:'Pending',value:'pending'},{text:'Active',value:'active'},{text:'Closed',value:'closed'}], // dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "User Defn Equip Sts",
        field: "user_defn_equip_status",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: "Manuf",
        field: "manuf",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: "Model",
        field: "model",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: "Year",
        field: "year",
        fpFieldType: "integer",
        filterable: true,
        hidden: false,
      },
      {
        label: "In Service Date",
        field: "in_service_date",
        fpFieldType: "custom_date",
        filterable: true,
        hidden: false,
      },
      {
        label: "Pool",
        field: "pool",
        fpFieldType: "option",
        filterable: true,
        hidden: false,
      },
      {
        label: "Last Returned Date",
        field: "last_returned_date",
        fpFieldType: "custom_date",
        filterable: true,
        hidden: false,
      },
      {
        label: "Days Idle",
        field: "days_idle",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: "Assigned Facility",
        field: "assigned_facility",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: "Facility Description",
        field: "facility_description",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: "OOS",
        field: "oos",
        fpFieldType: "option",
        filterable: true,
        hidden: false,
        filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Contract Equipment Status", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: ['Y','N'], // dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "OOS Date",
        field: "oos_date",
        fpFieldType: "custom_date",
        filterable: true,
        hidden: false,
      },
      {
        label: "For Sale",
        field: "for_sale",
        fpFieldType: "option",
        filterable: true,
        hidden: false,
        filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Contract Equipment Status", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: ['Y','N'], // dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Date For Sale",
        field: "date_for_sale",
        fpFieldType: "custom_date",
        filterable: true,
        hidden: false,
      },
      {
        label: "Reserved",
        field: "reserved",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Contract Equipment Status", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: ['Y','N'], // dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Reserved To Date",
        field: "reserved_to_date",
        fpFieldType: "custom_date",
        filterable: true,
        hidden: false,
      },
    ],
    batchProcess: 0,
    batchNum: "",
  }),
  watch: {
    permissions: function (permission) {
      var self = this;
      permission.forEach(function (permissions) {
        if (permissions.name === 'weekly_rental_report') {
          self.cantAccessPage = true;
        }
      });
      if (self.cantAccessPage === '') {
        self.cantAccessPage = false;
      }
    },
  },
  mounted: function () {
    var self = this;
    self.getPermissions();
  },
  methods: {
    cancelAll: function () {
      this.$refs.unitsWithoutActiveContractsReportTable.unselectAllInternal();
    },
    exportCheck: function() {
      var count = 0;
      var actionFlag = "";
      var data = this.$refs['unitsWithoutActiveContractsReportTable'].selectedRows;
      count = data.length;
      if(this.serverParams.selectedAll == true){
          actionFlag = "";
      }else if(count != 0 && count <= 100){
          actionFlag = "export";
      }
      this.exportReports(actionFlag);
    },
    loadList: function () {


      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      $.ajax({
        url: process.env.ROOT_API + "/units-without-active-contracts/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action
        },
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            if (self.action === "export" || self.action === "export_queue") {
              if (data.code === "201") {
                alert(data.message);
              } else {
                if (self.action === "export") {
                  self.excel = data.content.web;
                  var save = document.createElement("a");
                  save.href = self.excel;
                  save.download = data.content.web;
                  save.target = "_blank";

                  document.body.appendChild(save);
                  save.click();
                  document.body.removeChild(save);
                } else {
                  self.batchProcess = 1;
                  self.batchNum = data.content;
                }
              }
              self.action = "list";
              self.loadList();
            } else {
              // if (data.content.row !== undefined) {
                self.rows = data.content.row;
              // }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function (jqXHR) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'reservation-list-booking')
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/UnitsWithoutActiveContracts.vue